import { CanAccess } from '@modules/common/components/CanAccess';
import { ManageMetadataTableRow } from '@modules/integrationsV2/types';
import { EditRounded } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';

interface ManageMetadataTableActionsProps {
  onEditButtonClick: (metadata: ManageMetadataTableRow) => void;
  metadata: ManageMetadataTableRow;
}

export const ManageMetadataTableActions = ({
  onEditButtonClick,
  metadata,
}: ManageMetadataTableActionsProps) => {
  return (
    <>
      <Stack
        className="js-manage-metadata-row-action-button-group"
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={{
          opacity: 0,
          position: 'absolute',
          right: 5,
          height: 'max-content',
        }}
      >
        <Tooltip title="Edit metadata" disableInteractive>
          <CanAccess
            resource={PermissionResource.Metadata}
            operation={PermissionOperation.Write}
            tooltipPlacement="left"
          >
            <IconButton
              color="primary"
              size="small"
              onClick={() => onEditButtonClick(metadata)}
            >
              <EditRounded />
            </IconButton>
          </CanAccess>
        </Tooltip>
      </Stack>
    </>
  );
};
